import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
//import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import routes  from "./reducers/routesReducer";
import route from "./reducers/routeReducer";
import draftRoute from "./reducers/draftRouteReducer";
import routeCreatorState from "./reducers/routeCreatorStateReducer";
import routeMapSearchState from "./reducers/routeMapSearchStateReducer";
import user from "./reducers/userReducer";
import userNetworkSearchCriteria from "./reducers/userNetworkSearchCriteriaReducer"
import users from "./reducers/usersReducer";
import followers from "./reducers/followerReducer";
import following from "./reducers/followingReducer";
import groups from "./reducers/groupsReducer";
import groupInvitation from "./reducers/groupInvitationReducer";
import events from "./reducers/eventsReducer";
import auth from "./reducers/authReducer";
import settings from "./reducers/settingsReducer";
import notifications from "./reducers/notificationReducer";
import navItems from "./reducers/navItemsReducer";
import apiCallsInProgress from "./reducers/apiStatusReducer";
import timeline from "./reducers/timelineReducer";
import allowCookies from "./reducers/allowCookiesReducer";

export default function configureStore(history, initialState) {
  const reducers = {
        routes,
        route,
        user,
        userNetworkSearchCriteria,
        users,
        followers,
        following,
        groups,
        groupInvitation,
        events,
        auth,
        settings,
        notifications,
        navItems,
        routeMapSearchState,
        routeCreatorState,
        draftRoute,
        timeline,
        allowCookies,
        apiCallsInProgress
  };

  const middleware = [
      thunk,
      routerMiddleware(history)//, 
      //reduxImmutableStateInvariant()
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js